export default "__VITE_ASSET__DMXTaniA__"